import Product from "@/domain/product/Product";
import {ActionContext, ActionTree, GetterTree, Module, MutationTree} from "vuex";
import api from "@/api/backend-api";

export class ProductState {
  constructor(product: string | null) {
    if (product) {
      this.product = new Product(JSON.parse(product));
    }
  }

  public product?: Product;
}

const mutations: MutationTree<ProductState> = {
  setProduct(state: ProductState, product: Product): void {
    sessionStorage.setItem('product', JSON.stringify(product));
    state.product = new Product(product);
  },
};

const getters: GetterTree<ProductState, any> = {

};

const actions: ActionTree<ProductState, any> = {
  async fetchProduct(context: ActionContext<ProductState, any>, productId: string) {
    await api.getProductDetail(productId)
    .then(response => {
      context.commit('setProduct', new Product(response.data.result));
    });
  }
};

export const ProductStore: Module<ProductState, any> = {
  namespaced: true,
  state: new ProductState(sessionStorage.getItem('product')),
  getters,
  mutations,
  actions
};